import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.ReportCreatePopup', {
    title: 'New report',
    labelLoading: 'Loading data...',
    buttonBack: 'Go back',
    buttonNext: 'Next',
    buttonCreate: 'Create',
    errorReportNameRequired: 'Please provide the report name.',
    subtitleStepReportType: 'Step 1: Request type',
    subtitleStepFilters: 'Step 2: Filters',
    subtitleStepVisibleColumns: 'Step 3: Visible columns',
    subtitleStepReportName: 'Step 4: Name the report',
});
